import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export type CreateBagOptions = {
  chameleonRequestInstance: ChameleonRequest;
  store: string;
  customerId: string;
  lang: string;
  country: string;
  originCountry: string;
  keyStoreDataversion: string;
  authHeader: string;
  currency: string;
  sizeSchema: string;
  expand?: ExpandOptions;
  shop: string;
};

export type CreateBagResponse = {
  data: BagResponseV4;
  bagSessionToken: string;
};

export async function createBag({
  chameleonRequestInstance,
  store,
  customerId,
  lang,
  keyStoreDataversion,
  authHeader,
  currency,
  sizeSchema,
  country,
  originCountry,
  expand,
  shop,
}: CreateBagOptions): Promise<CreateBagResponse> {
  const expandQueryValue = buildExpandQueryValue(expand);

  const url = getApiUrl({
    path: `/commerce/bag/v4/customers/${customerId}/bags/getbag`,
    searchParams: {
      lang,
      keyStoreDataversion,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.post<BagResponseV4>(url, {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
        Authorization: authHeader,
      },
      body: JSON.stringify({
        currency,
        lang,
        sizeSchema,
        country,
        originCountry,
        shop,
      }),
    });

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
